import { BackendClubListing, Player, Position, getUnavailabilityTypeLabel, getUnavailabilityReasonLabel } from '../models/types';

export function mapClubListing(listing: BackendClubListing): Player {
  const p = listing.player;
  const positions: Record<string, Position> = {
    GOALKEEPER: 'POR', GK: 'POR', POR: 'POR',
    DEFENDER: 'DEF', DF: 'DEF', DEF: 'DEF',
    MIDFIELDER: 'MED', MF: 'MED', MED: 'MED',
    FORWARD: 'DEL', FW: 'DEL', ST: 'DEL', DEL: 'DEL',
  };
  return {
    id: listing.playerInstanceId,
    playerInstanceId: listing.playerInstanceId,
    playerDefinitionId: p.playerDefinitionId,
    listingId: listing.id,
    marketSource: 'CLUB_LISTING',
    name: p.displayName,
    shortName: p.displayName.split(' ').pop() || p.displayName,
    position: positions[p.position.toUpperCase()] || 'MED',
    rawPosition: p.position,
    age: p.age ?? 0,
    nationality: '',
    isAmateur: p.type === 'AMATEUR',
    playerType: p.type,
    clubId: listing.sellerClubId,
    realClub: p.realClub ?? undefined,
    clubName: p.realClub?.name,
    clubShortName: p.realClub?.shortName,
    listedForTransfer: true,
    askingPrice: listing.askingPrice == null ? undefined : listing.askingPrice / 1_000_000,
    currentMarketValue: p.marketValue / 1_000_000,
    averagePoints: p.averagePoints ?? null,
    last3AveragePoints: p.last3AveragePoints ?? null,
    unavailabilities: (p.unavailabilities || []).map(u => ({
      ...u,
      typeLabel: getUnavailabilityTypeLabel(u.type),
      reasonLabel: getUnavailabilityReasonLabel(u.reason),
    })),
    contract: { salary: 0, durationYears: 0, releaseClause: 0, acquisitionCost: 0, startSeason: 0, endSeason: 0 },
    formScore: 0,
  };
}

export function combineMarketPlayers(free: Player[], club: Player[]): Player[] {
  const players = new Map<string, Player>();
  // A current club advertisement takes precedence over a stale daily listing.
  for (const player of [...free, ...club]) players.set(player.playerInstanceId || player.id, player);
  return [...players.values()];
}
